import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useBlogPosts() {
  return useQuery({
    queryKey: ["blog-posts"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("blog_posts" as any)
        .select("id, title, slug, excerpt, cover_image, author, created_at, view_count")
        .eq("published", true)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data as unknown as Array<{
        id: string;
        title: string;
        slug: string;
        excerpt: string;
        cover_image: string | null;
        author: string;
        created_at: string;
        view_count: number;
      }>;
    },
  });
}

export function useBlogPost(slug: string, adminPreview = false) {
  return useQuery({
    queryKey: ["blog-post", slug, adminPreview],
    queryFn: async () => {
      let query = supabase
        .from("blog_posts" as any)
        .select("*")
        .eq("slug", slug);
      if (!adminPreview) {
        query = query.eq("published", true);
      }
      const { data, error } = await query.single();
      if (error) throw error;
      return data as unknown as {
        id: string;
        title: string;
        slug: string;
        excerpt: string;
        content: string;
        cover_image: string | null;
        author: string;
        published: boolean;
        created_at: string;
        view_count: number;
        category?: string;
      };
    },
    enabled: !!slug,
  });
}
